import axios from "axios";

import { getApiBaseUrl } from "../config/api";
import { authService } from "./auth";

export type CheckStatus = "ok" | "warn" | "bad" | "error" | "na" | "info";

export interface Check {
  status: CheckStatus;
  detail: string;
  duration_s?: number | null;
  completed_at?: string | null;
}

export interface StudyRow {
  study_uid: string;
  job_id: string | null;
  company: string | null;
  uploaded_by: string | null;
  series_count: number;
  slices: number | null;
  findings: number | null;
  received_by_device: string | null;
  upload: Check;
  canonicalize: Check;
  inference: Check;
  resent: boolean;
  status: string;
  message: string | null;
  error: { stage: string; message: string } | null;
  model: string | null;
}

export interface IntegrationStatusResponse {
  key: string;
  display_name: string;
  generated_at: string;
  health: { gateway: Check; device: Check; canonicalize: Check };
  studies: StudyRow[];
}

function authHeaders(): Record<string, string> {
  const { token } = authService.getStoredAuth();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchIntegrations(): Promise<Array<{ key: string; display_name: string }>> {
  const { data } = await axios.get(`${getApiBaseUrl()}/api/admin/integrations`, {
    headers: authHeaders(),
  });
  return data.integrations;
}

export async function fetchIntegrationStatus(key: string): Promise<IntegrationStatusResponse> {
  const { data } = await axios.get(`${getApiBaseUrl()}/api/admin/integration-status`, {
    params: { key },
    headers: authHeaders(),
  });
  return data;
}
